import { gql } from '@apollo/client'

export const UPDATE_USER = gql`
  mutation NotificationEnabledUpdate($payload: UpdateUserPayload) {
    updateUser(payload: $payload) {
      id
      email
      first_name
      last_name
      disabled
      profile_image_url
      notification_enabled
      user_role {
        id
        role {
          id
          name
          description
          role_permission {
            id
            permission {
              id
              name
            }
          }
        }
      }
      user_account {
        account {
          id
          name
          
        }
      }
    }
  }
`
